import { createIdentityClient } from "@the-drop/customer-shared/api/identity";
import { fetchWithClerkJwt } from "./fetch-with-clerk";

const client = createIdentityClient(fetchWithClerkJwt);

export const beginIdentityVerification = client.begin;
export const completeIdentityVerification = client.complete;

export {
  IdentitySessionError,
  formatIdentityError,
  type IdentityBeginResponse,
  type IdentityCompleteResponse,
} from "@the-drop/customer-shared/api/identity";
